import { OAuthLoginProviders } from "../reducer/user.reducer";
import { getLoginUrl } from "../services/apis/auth";
import { getRedirectUrl } from "./authentication";
import { isPinAuthGatePending } from "./pinBrowserFlags";

export const getAutoLoginProvider = (): OAuthLoginProviders =>
    import.meta.env.VITE_AUTO_LOGIN_PROVIDER as OAuthLoginProviders

export const redirectToAutoLogin = async (): Promise<void> => {
    if (isPinAuthGatePending()) return
    const url = await fetchLoginUrl(getAutoLoginProvider())
    if (isPinAuthGatePending()) return
    window.location.href = url
}

export const fetchLoginUrl = async (authProvider: OAuthLoginProviders): Promise<string> => {
    const request: { body: any } = { body: { authProvider } };

    switch(authProvider) {
        case OAuthLoginProviders.X:
            request.body.params = [{
                        key: 'redirectUrl',
                        value: getRedirectUrl('X')
                    }];
            break;
        case OAuthLoginProviders.GOOGLE:
            request.body.params = [{
                        key: 'redirectUrl',
                        value: getRedirectUrl('GOOGLE')
                    }];
            break;
        case OAuthLoginProviders.SHOONYA:
            request.body.params = [{
                        key: 'redirectUrl',
                        value: getRedirectUrl('SHOONYA')
                    }];
            break;
    }
    return (await getLoginUrl(request)).url;
}